import { render, staticRenderFns } from "./SelectDrug.vue?vue&type=template&id=b7007814&scoped=true"
import script from "./SelectDrug.vue?vue&type=script&lang=js"
export * from "./SelectDrug.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7007814",
  null
  
)

export default component.exports